import type { Feature } from '@exodus/dependency-types';

import testnetsApiDefinition from './api.js';
import { testnetsEnabledAtomDefinition } from './atoms.js';
import testnetsDefinition from './module.js';
import testnetsPluginDefinition from './plugin.js';

const testnets = () => {
  return {
    id: 'testnets',
    definitions: [
      { definition: testnetsDefinition },
      {
        definition: testnetsEnabledAtomDefinition,
        storage: { namespace: 'testnets' },
        aliases: [
          { interfaceId: 'storage', implementationId: 'unsafeStorage' },
        ],
      },
      { definition: testnetsPluginDefinition },
      { definition: testnetsApiDefinition },
    ],
  } satisfies Feature;
};

export default testnets;
